import toast from 'react-hot-toast'
import { downloadReportPdf } from '../../../reducers/adversaries'
import { useAppDispatch } from '../../../reducers/store'
import rawDataReportsStructure from './raw_data_reports_structure.json'
import AdversaryCard from '../../adversaries/AdversaryCard'
import { DEFAULT_TOAST_CONFIG } from '../../toast/consts'

function VisualizationNetworkPage() {
  const di = useAppDispatch()

  const adversariesWithImages = rawDataReportsStructure.map((intelReports) => ({
    ...intelReports,
    reports: intelReports.reports.map((report) => ({
      ...report,
    })),
  }))

  const downloadAdversaryReport = async (reportName: string) => {
    const bucket = import.meta.env.VITE_INTEL_REPORTS_BUCKET
    const downloaded = await di(downloadReportPdf(bucket, reportName))
    downloaded
      ? toast.success('Raw Data successfully downloaded', DEFAULT_TOAST_CONFIG)
      : toast.error('Failed to download report, please try again', DEFAULT_TOAST_CONFIG)
  }

  return (
    <div className="mx-auto max-w-[924px]">
      {adversariesWithImages.map((adversaryGroup) => (
        <div className="mb-6" key={adversaryGroup.sectionName}>
          <p className="text-lg font-medium">{adversaryGroup.sectionName}</p>
          <div className="grid grid-cols-2 gap-3 mt-3">
            {adversaryGroup.reports.map((report) => (
              <AdversaryCard
                reportName={report.reportName}
                execSummary={report.execSummary}
                downloadLink={report.downloadLink}
                downloadTitle="Download Raw Data"
                downloadAction={downloadAdversaryReport}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default VisualizationNetworkPage
